
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FedExVerificationMethod } from '../../types/fedexRegistration';

@Component
export default class FedExVerificationMethodStep extends Vue {
  @Prop({ default: false }) hasInvoiceOption!: boolean;

  @Prop({ default: false }) loading!: boolean;

  private selectedMethod: FedExVerificationMethod | null = null;

  created(): void {
    if (this.hasInvoiceOption) {
      this.selectedMethod = 'INVOICE';
    } else {
      this.selectedMethod = 'SECURE_CODE';
    }
  }

  private onSubmit(): void {
    if (!this.selectedMethod) return;
    this.$emit('submit', this.selectedMethod);
  }
}
